
class ModalsController {
    constructor($scope, ModalService) {
        'ngInject';
        
        this.service = ModalService;
    }
}

let modalsComponent = {
    bindings: {
        params: '<'
    },
    template: `<modal ng-repeat="modal in $ctrl.service.modals" params="modal" is-open="modal.isOpen"></modal>`,
    controller: ModalsController
}

export default modalsComponent;